import styled from "styled-components";
import { Select, MenuItem } from "@mui/material";
import { themePalette } from "../../theme";

export const ShortcutsContainer = styled.div`
  padding: 16px 24px 8px 24px;
  margin-bottom: -20px;
  background-color: ${themePalette.white};
`;

export const ShortcutsLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${themePalette.blueDark};
  margin-bottom: 4px;
`;

export const StyledSelect = styled(Select)`
  background-color: transparent;
  border-bottom: 1px solid ${themePalette.neutral300};

  &:hover {
    border-bottom: 1px solid ${themePalette.neutral500};
  }

  /* Override MUI Select default padding */
  .MuiSelect-select {
    color: ${themePalette.neutral700};
    padding-left: 0;
    padding-top: 4px;
    padding-bottom: 8px;
  }

  .MuiSelect-icon {
    right: 0;
  }
`;

export const GroupHeader = styled.div`
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 600;
  color: ${themePalette.neutral700};
  background-color: ${themePalette.neutral50};
  pointer-events: none;
`;

export const ShortcutMenuItem = styled(MenuItem)`
  && {
    padding: 10px 16px;
    font-size: 14px;

    &:hover {
      background-color: ${themePalette.greenPastel};
    }

    &.Mui-focusVisible {
      background-color: ${themePalette.greenPastel};
    }
  }
`;
